let dispatch_to_livewire = (actionData) => {
    if (typeof window.Livewire === 'undefined') {
        console.error('window.Livewire is undefined / livewire is not installed');
        return;
    }
    window.Livewire.dispatch(actionData.event, actionData.eventData);
};
export default dispatch_to_livewire;
